<template>
  <div>
    <nav-bar />
    <div class="grid0">
      <aside-menu @index-change="index = $event" />
      <div class="dashboard_grid">
        <div class="title-div">
          <title-bar @day-change="day = $event" :key="index+storageIndex" :selectedDate="day" :facilityName="curFacilityName" :facilityType="curFacilityType" />
        </div>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
          background-color="#000000"
        ></loading>
        <div class="max">
          <div v-if="curFacilityType === 'station'|| curFacilityType === 'isolated'" class="storages columns">
            <router-link to="#"><p class="column storage">All Storages</p></router-link>
            <ul v-for="(item, index) in tank" :key="index">
              <li>
                <button
                  class="is-flex storage column"
                  @click="getTankData(index)"
                  :class="{ active: storageIndex === index }"
                >
                  <b-icon icon="view-dashboard" size="is-small"> </b-icon>
                  <p>Storage {{ index + 1 }}</p>
                </button>
              </li>
            </ul>
          </div>
          <section v-if="(curFacilityType === 'station'||curFacilityType === 'isolated')" class="section is-main-section columns">
            <div class="container-div">
              <card-component
                title="Storage"
                @header-icon-click="fillChartData"
                icon="finance"
                class="column is-8 shadow margin"
                :lastFilledTime="lastFilledTime"
                :tankData='tankData'
              >
                <div v-if="defaultChart.chartData && tankData!== null && tankData.length > 0" class="chart-area">
                  <line-chart
                    style=""
                    ref="bigChart"
                    chart-id="big-line-chart"
                    :chart-data="defaultChart.chartData"
                    :extra-options="defaultChart.extraOptions"
                    :key="refreshChart"
                  >
                  </line-chart>
                </div>
                <div v-else class="no-data">
                  NO DATA FOR THIS DAY.
                </div>
              </card-component>
              <card-component class="column is-4 shadow">
                <div v-if="defaultChart.chartData && tankData!== null && tankData.length > 0" class="chart-area">
                  <p v-if="day" class="day">{{ todayDate }}</p>
                  <p v-else class="day">Current</p>
                  <div class="doughnut-div">
                      <DoughnutChart style="" :chart-data="doughnutChartData.chartData">
                    </DoughnutChart>
                  </div>
                  <div class="doughnut-footer">
                    <p>
                      Filled - <span class="day">{{ this.filled || "-" }} L</span>
                    </p>
                    <p>
                      Empty - <span class="day">{{ this.emptyTank.toFixed(1) || "-" }} L</span>
                    </p>
                    <!-- <p>
                      Net Change - <span class="day">{{ (this.filled - this.emptyTank).toFixed(1) || "-" }} L</span>
                    </p> -->
                  </div>
                </div>
                <div v-else class="no-data">
                  NO DATA FOR THIS DAY.
                </div>
              </card-component>
            </div>
          </section>
          <section v-if="curFacilityType === 'tanker'">
            <MapCard :key="index" :mapData="mapData" :lastFilledTime="lastFilledTime" :current="currentVolume">
            </MapCard>
          </section>
          <footer>
            <p>© Uptima Solutions 2021</p>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import AsideMenu from '@/components/AsideMenu.vue';
import * as chartConfig from '@/components/Charts/chart.config';
import TitleBar from '@/components/TitleBar.vue';
import CardComponent from '@/components/CardComponent.vue';
import MapCard from '@/components/MapCard.vue';
import LineChart from '@/components/Charts/LineChart';
import DoughnutChart from '@/components/Charts/Doughnut';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment';

const icon = {
  path: 'M -2,0 0,-2 2,0 0,2 z',
  strokeColor: '#A72424',
  fillColor: '#A72424',
  fillOpacity: 1,
  rotation: 45
};

const symbolThree = {
  path: 'M -2,0 0,-2 2,0 0,2 z',
  strokeColor: '#F00',
  strokeWeight: 3,
  fillColor: '#F00',
  fillOpacity: 1
};

export default {
  name: 'dashboard',
  components: {
    LineChart,
    DoughnutChart,
    CardComponent,
    TitleBar,
    AsideMenu,
    NavBar,
    Loading,
    MapCard
  },
  data: () => ({
    defaultChart: {
      chartData: null,
      extraOptions: chartConfig.chartOptionsMain
    },
    doughnutChartData: {
      chartData: {},
      extraOptions: chartConfig.baseChartOptions
    },
    lastFilledTime: 0,
    isLoading: false,
    fullPage: true,
    index: -1,
    day: new Date(),
    storageIndex: -1,
    facilityIndex: 0,
    gradient: null,
    items: null,
    tankColor: {},
    curFacilityType: null,
    curFacilityName: null,
    refreshChart: 0,
    refreshDoughnut: 0,
    refreshMap: 0,
    mapData: null,
    emptyTank: 0,
    filled: 0,
    checkTank: null,
    icons: [
      { icon, offset: '0%' },
      { icon: symbolThree, offset: '100%' }
    ],
    color: null,
    color2: null,
    currentVolume: 0
  }),
  watch: {
    'getLoggedUser.email': {
      immediate: true,
      handler(val) {
        if (val === 'admin01@uptima.ng') {
          setTimeout(() => {
            this.$router.push('/admin/company');
          }, 100);
        }
      }
    },
    getStatus(val) {
      if (val === 'loading') {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    },
    // storageIndex(val) {
    //   // this.defaultChart = {
    //   //   chartData: null,
    //   //   extraOptions: chartConfig.chartOptionsMain
    //   // };
    //   // const tankId = this.tank[val].id;
    //   // if (!(tankId in this.tankColor)) {
    //   //   this.tankColor[tankId] = this.getRandomColor();
    //   // }
    //   // this.color = this.tankColor[tankId].colourone;
    //   // this.color2 = this.tankColor[tankId].colourtwo;
    // },
    async day(newValue) {
      const day = moment(new Date(newValue)).format('YYYY-MM-DD');
      const tankData = {
        company_id: this.getLoggedUser.company_id,
        facility_id: this.facility[this.facilityIndex].id,
        tank_id: this.tank[this.storageIndex].id,
        on: day
      };
      await this.fetchSingleTankData(tankData);
      if (this.curFacilityType === 'isolated' || this.curFacilityType === 'station') {
        await this.fillChartData();
        await this.fillDoughnutData(this.storageIndex);
      } else if (this.curFacilityType === 'tanker') {
        await this.fillMapData();
      }
    },
    async index(newIndex) {
      this.facilityIndex = newIndex;
      this.emptyTank = 0;
      this.curFacilityName = this.facility[this.facilityIndex].facility_name;
      this.curFacilityType = this.facility[this.facilityIndex].facility_type;
      this.filled = 0;
      this.defaultChart.chartData = null;
      this.clearStore();
      const tanks = {
        company_id: this.getLoggedUser.company_id,
        facility_id: this.facility[this.facilityIndex].id
      };
      await this.fetchTankDetails(tanks);
      this.storageIndex = 0;
      this.tank.forEach((e) => {
        if (!(e.id in this.tankColor)) {
          this.tankColor[e.id] = {};
          this.tankColor[e.id].colorone = this.getRandomColor();
          this.tankColor[e.id].colortwo = this.lightenDarkenColor(this.tankColor[e.id].colorone);
        }
      });
      const day = moment().format('YYYY-MM-DD');
      if (this.tank.length) {
        const tankData = {
          company_id: this.getLoggedUser.company_id,
          facility_id: this.facility[this.facilityIndex].id,
          tank_id: this.tank[this.storageIndex].id,
          on: day
        };
        await this.fetchSingleTankData(tankData);
        this.color = this.tankColor[this.tank[0].id].colorone;
        this.color2 = this.tankColor[this.tank[0].id].colortwo;
      }
      if (this.curFacilityType === 'isolated' || this.curFacilityType === 'station') {
        await this.fillChartData();
        await this.fillDoughnutData(this.storageIndex);
      } else if (this.curFacilityType === 'tanker') {
        await this.fillMapData();
      }
    }
  },
  computed: {
    ...mapGetters(['getLoggedUser', 'getStatus']),
    ...mapGetters('apps', {
      tank: 'getTankDetails',
      tankData: 'getSingleTankData',
      facility: 'getFacilityDetails',
      staticData: 'getStaticData'
    }),
    titleStack() {
      return ['Admin', 'Dashboard'];
    },
    todayDate() {
      return moment().format('MM/DD/YYYY');
    }
  },
  async created() {
    this.init();
  },
  beforeRouteEnter(to, from, next) {
    if (to.path === '/login') {
      this.$buefy.snackbar.open({
        message: 'Welcome back',
        queue: false
      });
    }
    next();
  },
  beforeUpdate() {
    this.getCurrentVolumeAndLastFilledTime(this.staticData);
  },
  methods: {
    ...mapActions('apps', ['fetchTankDetails', 'fetchSingleTankData', 'fetchFacilityDetails', 'clearStore']),
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    lightenDarkenColor(col, amt = 40) {
      const num = parseInt(col.substring(1), 16);
      const r = (num >> 16) + amt;
      const b = ((num >> 8) & 0x00FF) + amt;
      const g = (num & 0x0000FF) + amt;
      let newColor = g | (b << 8) | (r << 16);
      newColor = newColor.toString(16);
      return `#${newColor}`;
    },
    async init() {
      await this.fetchFacilityDetails(this.getLoggedUser.company_id);
      this.index = 0;
    },
    async getTankData(i) {
      this.storageIndex = i;
      this.emptyTank = 0;
      this.filled = 0;
      const day = moment().format('YYYY-MM-DD');
      const tankData = {
        company_id: this.getLoggedUser.company_id,
        facility_id: this.facility[this.facilityIndex].id,
        tank_id: this.tank[i].id,
        on: day
      };
      this.color = this.tankColor[this.tank[i].id].colorone;
      this.color2 = this.tankColor[this.tank[i].id].colortwo;
      await this.fetchSingleTankData(tankData).then(() => {
        this.fillChartData();
        this.fillDoughnutData(i);
      });
      // await Promise.all([ this.fetchSingleTankData(tankData),
      //   this.fillChartData(),
      //   this.fillDoughnutData(i)]);
    },
    pieChart(i) {
      if (this.tankData.length > 0) {
        const totalVolume = this.tank[i].total_volume;
        const lastIndex = this.tankData.length - 1;
        const empty = totalVolume - this.tankData[lastIndex].volume_left;
        this.filled = Number(this.tankData[lastIndex].volume_left).toFixed(0);
        this.emptyTank = empty;
        return [empty, this.tankData[lastIndex].volume_left];
      }
      return [0, 0];
    },
    volumeLeftData() {
      if (this.tankData.length > 0) {
        const data = this.tankData.map(el => el.volume_left);
        return data;
      }
      return null;
    },
    hourData() {
      if (this.tankData.length > 0) {
        const hour = this.tankData.map(i => this.convertUTCDateToLocalDate(i.created_at));
        return hour;
      }
      return null;
    },
    fillChartData() {
      this.defaultChart.chartData = {
        datasets: [
          {
            borderColor: this.color,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: this.color,
            pointBorderColor: this.color,
            pointHoverBackgroundColor: this.color2,
            pointBorderWidth: 5,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            backgroundColor: this.color2,
            data: this.volumeLeftData()
          }
        ],
        labels: this.hourData()
      };
      this.refreshChart = (this.refreshChart > 10) ? 0 : this.refreshChart++;
    },
    fillMapData() {
      this.mapData = this.tankData;
      this.refreshMap++;
    },
    fillDoughnutData(i) {
      this.doughnutChartData.chartData = {
        datasets: [
          {
            data: this.pieChart(i),
            backgroundColor: ['#C4C4C4', this.color2]
          }
        ],
        labels: ['Empty', 'Filled'],
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              return `${data.labels[tooltipItem.index]}: ${data.datasets[0].data[tooltipItem.index]}%`;
            }
          }
        }
      };
    },

    convertUTCDateToLocalDate(date) {
      const theDate = new Date(Date.parse(
        date
      ));
      const localTime = theDate.toLocaleString();

      const newDate = localTime.split(',')[1].split(':')[0];

      return newDate;
    },

    getCurrentVolumeAndLastFilledTime(data) {
      const now = moment(new Date()); // todays date
      const end = moment(data.lastFilledTime); // another date
      const duration = moment.duration(now.diff(end));
      // console.log(Math.round(Math.abs(duration.as('hours'))));
      this.lastFilledTime = Number.isNaN(Math.round(Math.abs(duration.as('hours')))) ?
        0 : Math.round(Math.abs(duration.as('hours')));
      this.currentVolume = Math.abs(data.currentVolume);
    }
  }
};
</script>

<style scoped>
.max {
  padding-left: 1rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
  position: relative
}
.title-div {
  padding-left: 1rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
}
.storages {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #817f7f;
  width: 50%;
  padding-left: 1.5rem;
}
.shadow {
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(5, 0, 255, 0.15);
}
.margin {
  margin-right: 20px;
}
.storage {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #3887f6;
}
.active {
  color: #5051db !important;
  border-bottom: 2px solid #5051db;
}
.storage p {
  margin-left: 10px;
}
.doughnut-div{
  width: 100%;
  height: 350px;
  align-content: center;
}
.doughnut-footer {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
}
.map {
  padding: 50px 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(5, 0, 255, 0.15);
  display: grid;
  grid-template-columns: 3fr 1fr;
}
.card {
  /* margin-left: 20px; */
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  min-height: 560px;
  align-content: center;
  align-items: center;
  position: relative;
  /* padding: 20px 0; */
}
.card h3 {
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  color: #000000;
}
.card-tanker {
  display: flex;
  margin-left: 30px;
  align-items: center;
  margin-top: 30px;
}
.card-tanker h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #3887f6;
  margin-left: 10px;
}
.container-div {
  display: flex;
  width: 100%;
  height: 100%;
}
.day {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin-bottom: 20px;
}
.map-footer {
  margin-top: 30px;
}
.map-footer,
.map-footer-sub {
  display: flex;
  align-items: center;
}
.map-footer-sub p {
  margin-left: 10px;
}
.green {
  margin-left: 10px;
}
.refresh {
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #3887f6;
  margin-top: 16px;
}
section {
  padding: 24px !important;
}
footer {
  text-align: center;
  padding: 25px 0 0 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}
.no-data {
  height: 60vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
@media screen and (max-width: 768px) {
  .map {
    grid-template-columns: 1fr;
  }
  .map-footer {
    display: none;
  }
  .max {
    padding: 0.5rem;
  }
  .margin {
    margin-right: 0;
  }
  .shadow {
    margin-top: 20px;
  }
  .title-div {
  padding-left: 1rem;
  position: relative
  }
  .container-div {
    flex-direction: column;
  }
}
@media screen and (min-width: 1024px) {
  .title-div {
  padding-left: 17rem;
  }
  .max {
  padding-left: 17rem;
  }
}
</style>

<style>
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 60vh;
  font-size: 16px;
  font-weight: 600;
}
.title-div {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
}
</style>
